import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { UsersList } from '../../components/UsersList';
import { ManageSpecificAccountUserRoutes } from '../management/ManageSpecificAccountUserRoutes';
import { CropsList } from '../management/CropsList';
import { ManageCropRoutes } from '../management/ManageCropRoutes';
import { AddUser } from '../management/AddUser';
import { AgenciesList } from './AgenciesList';
import { ManageSpecificAgencyRoutes } from './ManageSpecificAgencyRoutes';
import { AddAgency } from './AddAgency';
import { GeneratedPDFsList } from './GeneratedPDFsList';
import SystemSettings from './SystemSettings';
import TranscriptionLogs from './TranscriptionLogs';

export function AdminRoutes() {
    const {
        currentUser
    } = useAuth();

    if (!(currentUser.is_agency_admin || currentUser.is_super_super_user)) {
        return <Navigate to="/" />
    }

    return <>
        <Routes>
            {/* /admin/agencies */}
            <Route path="agencies" element={
                <AgenciesList />
            } />
            <Route path="agencies/:agencyUniqueId/*" element={
                <ManageSpecificAgencyRoutes />
            } />
            <Route path="add-agency" element={
                <AddAgency />
            } />
            <Route path="users" element={
                <div className="container-fixed">
                    <UsersList />
                </div>
            } />
            <Route path="users/:userUniqueId/*" element={
                <ManageSpecificAccountUserRoutes />
            } />
            <Route path="add-user" element={
                <AddUser />
            } />
            <Route path="manage-crops" element={
                <div className="container-fixed">
                    <CropsList />
                </div>
            } />
            <Route path="manage-crops/:cropUniqueId/*" element={
                <ManageCropRoutes />
            } />
            {/* Generated PDFs */}
            <Route path="generated-pdfs" element={
                <GeneratedPDFsList />
            } />
            {/* System Settings - chris@cohoat.tech Only */}
            {currentUser.email === 'chris@cohoat.tech' && (
                <>
                    <Route path="system-settings" element={<SystemSettings />} />
                    <Route path="system-settings/:tab" element={<SystemSettings />} />
                    <Route path="system-settings/:tab/:promptType" element={<SystemSettings />} />
                    <Route path="transcription-logs" element={<TranscriptionLogs />} />
                </>
            )}
            <Route
                path="*"
                element={<Navigate
                    to={`/admin/agencies`}
                    replace
                />}
            />
        </Routes>
    </>
}